import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';

const FullLogo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className,
    'col-4'
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <div className="header-fill">
        <Link to="/">
          <Image
          className="img"
            src={require('./../../../assets/images/EDSLOGO.png')}
            alt="Open" 
            />
        </Link>
      </div>
    </div>
  );
}

export default FullLogo;